import React from 'react'
import { astroElements, astroInfo } from '../../static/astro'
import { AstroIcon } from './AstroIcon'

export const AstroSign = ({sign = 'Aries', size = 20}) => {
  return (
    <AstroIcon name={sign} size={size} />
  )
}
export const AstroBg = ({sign = 'Aries', style = {}}) => {
  const getElementColor = (sign) => {
    return astroElements[astroInfo[sign]?.element] || 'transparent';
  }
  return (
    <div 
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        backgroundColor: getElementColor(sign),
        ...style
      }}
    ></div>
  )
}